// @ts-nocheck
import { getSessionId } from '@aspendental/shared-utils/utils';

import { IglobalThis, Maybe } from '@shared-components-web/types';
import { objectKeyToSnake } from '@shared-components-web/utils/camelCaseToSnake';
import { getDeviceType } from '@shared-components-web/utils/getDeviceType';

declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace globalThis {
		let dataLayer: Array<Record<string, unknown>>;
		let dispatchDataLayer: (config: IDataLayerEventConfig) => void;
	}
}

globalThis.dispatchDataLayer = (config: IDataLayerEventConfig) => {
	dataLayerConfig({
		...config,
	});
};

export interface IDataLayerEventConfig {
	[key: string]: Maybe<string | boolean | number | undefined | Record<string, unknown>>;
}

const removeQueryParams = (url?: string): string | undefined => {
	return url?.split('?')[0];
};

export const dataLayerConfig = (eventConfig: IDataLayerEventConfig = { event: '' }) => {
	// transform object keys that come from contentful to snake case because InfoTrust
	// newConfig should be the same as eventConfig, just snake_case
	const newConfig = objectKeyToSnake(eventConfig);

	const { page_origin_url } = newConfig;

	globalThis.dataLayer = (globalThis as IglobalThis).dataLayer || [];

	const defaultConfig = {
		tag_session_id: getSessionId(),
		platform: 'NextJS',
		page_origin_name: globalThis?.document?.title,
		page_origin_url: removeQueryParams(page_origin_url ?? globalThis?.location?.href),
	};

	// Removing contentful_metadata and sys are temporary
	// those keys are only present due to how the manual events are needed to be used
	// will be deprecated during a Contentful clean up
	Object.keys(newConfig).forEach(
		(key) =>
			(key === '__typename' ||
				key === 'contentful_metadata' ||
				key === 'sys' ||
				newConfig[key] === undefined ||
				newConfig[key] === null ||
				newConfig[key] === '') &&
			delete newConfig[key]
	);

	globalThis.dataLayer.push({
		...defaultConfig,
		...newConfig,
	});
};

export const mapSearchClickEvent = (params?: { numResults?: number }) => {
	const eventConfig = {
		event: 'mapbox_search_click',
		...(params && 'numResults' in params ? { num_results: params.numResults } : {}),
	};

	dataLayerConfig(eventConfig);
};

export interface IVirtualPageViewParams {
	brand: string;
	websiteSelectedFacilityId?: string;
	websiteSelectedFacilityName?: string;
}

export const virtualPageViewEvent = (params: IVirtualPageViewParams) => {
	dataLayerConfig({
		event: 'virtual_page_view',
		virtual_page_url: removeQueryParams(globalThis?.location?.href),
		virtual_page_title: globalThis?.document?.title,
		brand: params.brand,
		device_type: getDeviceType(),
		...(params.websiteSelectedFacilityId && { website_selected_facility_id: params.websiteSelectedFacilityId }),
		...(params.websiteSelectedFacilityName && {
			website_selected_facility_name: params.websiteSelectedFacilityName,
		}),
	});
};
